import { ApiError } from '@types';

export const getApiErrorMessage = (error: unknown): string | undefined => {
  const apiError = error as ApiError;
  const firstFieldError = apiError?.data?.errors?.[0]?.message;

  if (firstFieldError) {
    return firstFieldError;
  }

  return apiError?.data?.message;
};

export default getApiErrorMessage;
